module.exports = __webpack_public_path__ + "img/missaoHome_1_small.e7b75906.jpg";